import {Injectable} from '@angular/core';
import {BaseModelService} from '../../base-model.service';

@Injectable({
  providedIn: 'root'
})
export class ProviderPurchasesReportModelService extends BaseModelService {
  tableName = 'yu_v3_provider_purchases_report';
}
